import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { FinMasonError, FinMasonErrorResponse, } from "../types";
import { PortfolioPlanClassification } from "./getPortfolioPlanAssignmentClassificationById";
export const url = () => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/-/classification`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/-/classification`;
export const postVirtualPortfolioPlanClassification = async (positionsOrDetails, config) => {
    const { data, status } = await axios.post(url(), positionsOrDetails, {
        headers: {
            version: "20250221",
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
            ["idempotency-key"]: `VirtualPortfolioPlanClassification:${Date.now()}`,
        },
        validateStatus: () => true,
    });
    if (status === 550) {
        const parsed = FinMasonErrorResponse.parse(data);
        if (parsed.details.statusCode === "FIN_MASON_UNKNOWN_ASSET") {
            return new FinMasonError(parsed.message, parsed.details.invalidPositions);
        }
        throw new Error("Unexpected FinMason error");
    }
    if (status >= 300) {
        const errorMessage = `[postVirtualPortfolioPlanClassification.ts] received status code ${status}`;
        errorLog(errorMessage, data);
        throw new Error(errorMessage);
    }
    const decoded = PortfolioPlanClassification.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    const errorMessage = `[postVirtualPortfolioPlanClassification.ts] received unexpected data`;
    errorLog(errorMessage, decoded.error.message);
    throw new ValidationError(errorMessage, decoded.error.issues);
};
//# sourceMappingURL=postPositionsOrVirtualPortfolioPlanClassification.js.map